import React from 'react'

import { findReplyByQuestionId, getReplyValue } from '../../_helpers/pdfHelpers'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import Separator from '../../../../../components/pdf/Separator'
import { Col } from '../../../../../components/pdf/Grid'
import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import { formatDate } from '@btime/helpers'

const CertificateWithImageTemplate = () => {
  const parentServiceOrder = useServiceOrder()

  const name = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 59))
  const document = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 60))
  const dateTime = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 61))
  const period = formatDate('DD [de] MMMM [de] YYYY', dateTime)

  const courseHours = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 62))
  const place = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 63))

  return (
    <>
      <View
        style={{
          minHeight: '18.7cm',
          maxWidth: '27.9cm',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundImage: 'url("/pdfs/bosi/certificates/certificado-front-background.jpg")',
          backgroundSize: '100% 100%'
        }}
      >
        <Col gutter={40}>
          <Text size={20} align="center">
            Certificamos que <strong>{name}</strong> – <strong>CPF {document}</strong>, <br />
            participou do <strong>
              "Curso Formação da Brigada de Incêndio de acordo com a norma NR-23“
            </strong> <br /> com aprovação atingindo a média geral ponderada de aproveitamento. <br /> Carga horária de{' '}
            <strong>{courseHours} horas</strong>, realizado no período de{' '}
            <strong>
              {period}, <br />
            </strong>
            Realizado no <strong>ESPAÇO DE TREINAMENTOS DA BOSI TERRAPLANAGEM LTDA, EM SETE LAGOAS – MG</strong>.
          </Text>
          <Separator weight={6} />
          <Text size={20} align="center">
            <strong>
              {place}, {period}
            </strong>
          </Text>
        </Col>
      </View>

      <View
        style={{
          minHeight: '18.7cm',
          maxWidth: '27.9cm',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundImage: 'url("/pdfs/bosi/certificates/certificado-back-background.jpg")',
          backgroundSize: '100% 100%'
        }}
      ></View>
    </>
  )
}

export default CertificateWithImageTemplate
